import performanceNow from './vendor/performanceNow';
import { HistoryInstance } from './internal/types';
import memoizeOne from 'react-utils/memoizeOne';

interface HistoryV4Instance {
  location: { pathname: string };
  listen: (listener: (location: { pathname: string }) => void) => () => void;
}

export default memoizeOne((history: HistoryV4Instance): HistoryInstance => {
  const {
    location: { pathname: initialPathname },
  } = history;

  return {
    pathname: initialPathname,
    listen: (cb) =>
      history.listen(({ pathname }) => {
        const timestamp = performanceNow();
        cb({
          timestamp,
          pathname,
        });
      }),
  };
});
